var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.609,
    height: 14.609,
    viewBox: "0 0 14.609 14.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_add-square",
    "data-name": "vuesax/bulk/add-square",
    transform: "translate(-620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-square",
    transform: "translate(620)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.638,0h-5.1A3.249,3.249,0,0,0,0,3.537v5.1a3.25,3.25,0,0,0,3.537,3.543h5.1a3.249,3.249,0,0,0,3.537-3.537v-5.1A3.241,3.241,0,0,0,8.638,0Z",
    transform: "translate(1.217 1.217)",
    fill: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H14.609V14.609H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M.605,0H4.5a.61.61,0,0,1,.605.605.61.61,0,0,1-.605.605H2.066L8.3,7.441a.609.609,0,0,1,0,.855.6.6,0,0,1-.855,0l-6.23-6.23V4.5a.61.61,0,0,1-.605.605A.61.61,0,0,1,0,4.5V.605A.61.61,0,0,1,.605,0Z",
    transform: "translate(7.304 13.296) rotate(-135)",
    fill: "#191919"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.31239529496936fc64dd2f7e63c9eb26.svg";
export { ForwardRef as ReactComponent };